import { useTranslation } from '../../i18n';

interface FailedStateProps {
  onRetry?: () => void;
}

export function FailedState({ onRetry }: FailedStateProps = {}) {
  const { t } = useTranslation();

  return (
    <div className="bg-surface-interactive dark:bg-surface-interactive-dark border border-interactive dark:border-interactive-dark rounded-2xl p-8 shadow-interactive max-w-md mx-auto">
      <div className="flex flex-col items-center justify-center text-center">
        <div className="w-16 h-16 mb-6 text-red-500 flex items-center justify-center rounded-full bg-red-50 dark:bg-red-900/20">
          <span className="material-symbols-outlined text-3xl">error</span>
        </div>
        <h3 className="text-xl font-semibold text-theme-text dark:text-white mb-3">{t('creationDetails.processingFailed.title')}</h3>
        <p className="text-theme-hint mb-6">{t('creationDetails.processingFailed.description')}</p>
        
        {onRetry && (
          <button 
            onClick={onRetry}
            className="px-5 py-2.5 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors flex items-center gap-2"
          >
            <span className="material-symbols-outlined text-sm">refresh</span>
            {t('creationDetails.processingFailed.retryButton')}
          </button>
        )}
      </div>
    </div>
  );
} 